module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback4-7f6d7050606b496575cbf8160487e5f8.jpg";